import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import { experienceSchema } from '../../../constants/schemas';
import Input from '../../common/input';
import DatePicker from '../../common/datePicker';
import { Button } from '@material-ui/core';
import { faPlus, faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProjectArray from './projectArray';
import Searcher from '../../../components/role/searcher';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '1.5625rem 1.25rem',
  },
  title: {
    lineHeight: '1.75rem',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '1.8125rem',
  },
  date: {
    fontColor: 'black',
    backgroundColor: 'white'
  },
  position: {
    width: '400px',

  },
});


const ExperienceForm = ({ title, company, since, until, positions: initialPositions, onSubmit, reloadCandidateUpdatedAtData }) => {
  const classes = useStyles();
  const [positions, setPositions] = useState(initialPositions);
  const { control, errors, handleSubmit, setValue, getValues, reset } = useForm({
    resolver: yupResolver(experienceSchema),
    defaultValues: { positions }
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "positions",
  });

  const submitData = (data) => {
    onSubmit(data);
    setValue('company', '');
    setValue('since', null);
    setValue('until', null);
    reset({ positions });
  }

  // console.log(errors);
  // console.log('getValues', getValues());

  return (
    <Grid className={classes.root}>
      <form>
        <Typography className={classes.title} variant="button" component="h4">
          New Company
        </Typography>
        <Grid container direction="row" spacing={3}>
          <Grid item>
            <Controller
              control={control}
              name="company"
              defaultValue={company}
              render={({ onChange, onBlur, value }) => (
                <Input
                  placeholder="Company"
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  invalid={errors && errors.company}
                  message={errors && errors.company && errors.company.message}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              control={control}
              name="since"
              defaultValue={since}
              render={({ onChange, onBlur, value }) => (
                <DatePicker
                  className={classes.date}
                  label="Since"
                  id="DatePicker-experience-since"
                  date={value}
                  openTo="year"
                  views={["year", "month"]}
                  autoOk={true}
                  //format={"MMMM yyyy"}
                  //disableFuture={true}
                  maxDate={new Date()}
                  maxDateMessage={'Date should not be after today'}
                  onChange={(date) => onChange(date ? `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}` : null)}
                  //onChange={(date) => onChange(date?date:null)}
                  invalid={errors && errors.since}
                  message={errors && errors.since && errors.since.message}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              control={control}
              name="until"
              defaultValue={until}
              render={({ onChange, onBlur, value }) => (
                <DatePicker
                  id="DatePicker-experience-until"
                  className={classes.date}
                  label="Until"
                  date={value}
                  openTo="year"
                  views={["year", "month"]}
                  autoOk={true}
                  maxDate={new Date()}
                  maxDateMessage={'Date should not be after today'}
                  //minDate={getValues().since}
                  //minDateMessage={'Date should not be before "Since" date'}
                  onChange={(date) => onChange(date ? `${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}` : null)}
                  //onChange={(date) => onChange(date?date:null)}
                  invalid={errors && errors.until}
                  message={(errors && errors.until && errors.until.message)
                    || !value && "Until date is 'Current / Present'"}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid>
          {fields.map((position, index) => {
            const fieldName = `positions[${index}]`;
            return (
              <Grid container item className={classes.root} key={position.id}>
                <Controller
                  control={control}
                  name={`${fieldName}.name`}
                  defaultValue={position.name}
                  render={({ onChange, onBlur, value }) => (
                    <Grid container direction="column">
                      <Grid item>
                        <Typography className={classes.title} variant="button" component="h4">
                          Position
                        </Typography>
                      </Grid>
                      <Grid container item direction="row" spacing={2}>
                        <Grid item>
                          <Button variant="contained" color="primary"
                            onClick={() => append({ name: '', projects: [{ name: '', description: '', skills: [] }] })}>
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                        </Grid>
                        <Grid item>                                                  
                          <Searcher
                          className={classes.position}
                                  value={value}
                                  startIcon={<FontAwesomeIcon icon={faSearch} />}
                                  invalid={errors && errors[`positions`] && errors[`positions`][`${index}`] && errors[`positions`][`${index}`].name}
                                  message={errors && errors[`positions`] && errors[`positions`][`${index}`] && errors[`positions`][`${index}`].name && errors[`positions`][`${index}`].name.message}
                                  onSelect={(val) => {
                                    if (val) {
                                      setValue(`${fieldName}.name`, val.hash);
                                    } 
                                  }}
                                />
                        </Grid>
                        <Grid item>
                          <Button variant="outlined" color="primary" onClick={() => fields.length > 1 && remove(index)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                />
                <ProjectArray className={classes.root} nestIndex={index} {...{ control, errors, setValue, getValues }} />
              </Grid>
            );
          })}
        </Grid>
        <Button variant="contained" color="primary" onClick={handleSubmit(submitData)}>
          ADD NEW EXPERIENCE
        </Button>
      </form>
    </Grid>
  );
};

ExperienceForm.defaultProps = {
  company: '',
  since: null,
  until: null,
  positions: [{
    name: '',
    projects: [
      // {
      //   name: '',
      //   description: '',
      //   skills: []
      // }
    ]
  }]
};

ExperienceForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ExperienceForm;
